import React from 'react';
import browser from 'bowser';
import classnames from 'classnames';

import Row from '../components/row';
import Title from '../components/title';
import imgDesayuno from './images/desayuno.jpg'
import imgPiscina from './images/piscina.jpg'
import imgLounge from '../gallery/images/gallery.19.jpg';
import imgBicis from '../gallery/images/gallery.3.jpg';
import imgGarage from './images/garage.png';


const Image = ({img, inverse}) => {
  return (
    <div className={classnames({'img-services': !browser.mobile})}>
      <img role="presentation" className="img-responsive" src={img} />
    </div>
  )
}
const Text = ({children, title, inverse}) => {
  return (
    <div className={classnames({'text-right': inverse, 'text-left': !inverse})}>
      <h3 className={classnames('title-services', {'title-services-right': inverse})}>{title}</h3>
      {children}
    </div>
  )
}

const ItemService = ({children, title, img, index, first}) => {
  const inverse = index % 2 !== 0

  return (
    <div className={classnames('mt30', {'col-xs-12': !browser.mobile})}>
      {!first && <hr/>}
     {index % 2 === 0 || browser.mobile ?
       <div>
         <div className={classnames({'col-xs-offset-1 col-xs-4': !browser.mobile})}>
           <Image img={img} inverse={inverse} />
         </div>
         <div className={classnames({'col-xs-6': !browser.mobile})}>
           <Text children={children} title={title} inverse={inverse}/>
         </div>
       </div>
       :
       <div className={classnames({'pull-right': !browser.tablet})}>
         <div className={classnames({'col-xs-offset-1 col-xs-6': !browser.mobile})}>
           <Text children={children} title={title} inverse={inverse}/>
         </div>
         <div className={classnames({'col-xs-4': !browser.mobile})}>
           <Image img={img} inverse={inverse}/>
         </div>
       </div>
     }
    </div>
  )
}

const Services = () => {
  return (
    <Row>
      <Title title="Servicios" />
      <ItemService index={0} first={true} img={imgDesayuno} title="Desayuno Buffet">
        <p className="p-services">
          Cada mañana, en nuestro desayunador de techo vidriado, ofrecemos una gran variedad de productos caseros y artesanales.
        </p>
      </ItemService>
      <ItemService index={0} img={imgPiscina} title="Piscina">
        <p className="p-services">
          Nuestra piscina es de agua salada, lo que favorece al medio ambiente al evitar el uso de otro tipo de productos.
          Cuenta con un deck y reposeras, en un ambiente de completo relax como lo es nuestro jardín, rodeado de arboles y plantas.
          Ademas tenemos una parrilla, que pueden utilizar si así lo desean.<br/>
          Las bebidas las proveemos en la posada.
        </p>
      </ItemService>
      <ItemService index={0} img={imgLounge} title="Lounge">
        <p className="p-services">
          Un ambiente donde podrá descansar, calefaccionado en invierno con uno de nuestros dos hogares a lena. Aquí podrán leer un libro de nuestra biblioteca, tomar un juego de mesa, utilizar nuestras computadoras con internet o ver algún programa en la TV.
          Ofrecemos una carta de cafe, te, bebidas y sandwiches especiales. Muchos de los ingredientes de los mismos los sacamos de nuestra huerta.
        </p>
      </ItemService>
      <ItemService index={0} img={imgBicis} title="Alquiler Bicicletas">
        <p className="p-services">
          Ofrecemos bicis de paseo y trek para recorrer las calles de Colonia. <br/>
          Incluso tenemos preparados circuitos para proponerles.
        </p>
      </ItemService>
      <ItemService index={0} title="Garage" img={imgGarage}>
        <p className="p-services">
          Contamos con garage descubierto para la tranquilidad de nuestros huéspedes
        </p>
      </ItemService>
    </Row>
  )
}

export default Services;



// WEBPACK FOOTER //
// ./src/services/index.js